/**
 * 申诉理由配置
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, InputNumber } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import ReasonModal from './modal/ReasonModal';
import model from '@/reducers/system/parameter/model';

class ApplyReason extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
        ParamValueByCode: 0,
    }

    componentDidMount() {
      this.getParamValueByCode();
    }
    getParamValueByCode = () => {
        //根据code获取系统参数值
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.getParamValueByCode', {
            paramCode: 'RIDER_APPEAL_DAY'
        }, 'POST').then((res) => {
            if (res.errCode == 0) {
                this.setState({ ParamValueByCode: Number(res.result) });
            }
        }).catch((reject = {}) => {
            message.error(reject.message);
        });
    }
    // 新建申诉理由
    _createRule = () => {
        this.setState({
            currentOpenMode: 'CREAT',
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlistAppealReasons(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }


    // 表格操作
    _tableAction = (item, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.setState({
                    currentOpenMode: 'EDITOR',
                    openModeParam: value,
                });
                break;
            case 'switch':
                http('/?cmd=com.xqxc.api.pig.mis.biz.rider.AppealReasonsMisService.updateAppealReasonsStatus', {//状态
                    id: item.id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this._searchHandle('useCache');
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });

                break;
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }
    onChange = e => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.updateAdminParamValue', {
            paramCode: 'RIDER_APPEAL_DAY',
            paramValue: e.currentTarget.defaultValue,
        }, 'POST').then(() => {
            message.success('修改成功');
            this.getParamValueByCode();
        }).catch((reject = {}) => {
            message.error(reject.message);
        });
    }


    // 打开弹窗（创建/编辑）
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'CREAT':
                return <ReasonModal title='申诉理由' visible={true} closeMode={this._closeMode} />;
            case 'EDITOR':
                return <ReasonModal title='申诉理由' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this._searchHandle('useCache');// 重新渲染更新列表
        }
    }

    render() {
        const { listAppealReasons } = this.props;
        const { ParamValueByCode } = this.state;
        return (
            <KeepAlive id='4' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <div>
                        <div style={{ fontSize: 16, fontWeight: 'bold' }}>骑士申诉期时长</div>
                        <div>骑士收到罚单后，可在 <InputNumber
                            style={{ width: 180 }}
                            min={1}
                            max={10}
                            precision={0}
                            value={ParamValueByCode}
                            onBlur={this.onChange}
                            placeholder='请输入'
                        /> 天内提出申诉，超过时间后不可再起申诉</div>
                    </div>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建申诉理由' onClick={this._createRule} />
                    </div>
                    <TableContent renderData={listAppealReasons} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

ApplyReason.propTypes = {
    history: PropTypes.object, // 路由history对象
    listAppealReasons: PropTypes.object,
    getlistAppealReasons: PropTypes.func,//表格数据(action)
    // getParamValueByCode: PropTypes.func,
    // ParamValueByCode: PropTypes.number
};

const mapStateToProps = (state) => {
    return {
        listAppealReasons: state.parameter.listAppealReasons,
        // ParamValueByCode: state.parameter.ParamValueByCode
    };
};
export default connect(mapStateToProps, { ...model.actions })(ApplyReason);
